import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import {css} from 'styled-components';
import ComponentStyles from 'styles/mixins/Component.styles';
import List from '@mui/material/List';
import utils from 'helpers/utils';

const StyledList = styled(List)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--list-gap': utils.isDefined(props.$gap) ? props.theme.layout(props.$gap) : null,
      '--list-gap-half': utils.isDefined(props.$gap) ? props.theme.layout(props.$gap / 2) : null
    };

    return utils.styleProps(attr, vars);
  })`
  outline: none;

  &.List-orientation {
    &-vertical {
      width: 100%;
      
      &.List {
        > .ListItem {
          height: unset;
        }
        
        ${props => utils.isDefined(props.$gap) ? css`
          ${(Boolean(props.$divider) || (Boolean(props.$virtualize) && !Boolean(props.$sortable))) ? css`
            > .ListItem:not(:last-child) {
              padding-bottom: ${props => props.$css.$var('--list-gap-half', false)};
            }
        
            > .ListItem:not(:first-child) {
              padding-top: ${props => props.$css.$var('--list-gap-half', false)};
            }
          `: (Boolean(props.$virtualize) && Boolean(props.$sortable)) ? css`
              > .ListItem {
                padding-bottom: ${props => props.$css.$var('--list-gap', false)};
              }
          ` : css`
            display: flex;
            flex-direction: column;
            row-gap: ${props => props.$css.$var('--list-gap', false)};
          `}
         ` : null}

        ${props => Boolean(props.$divider) ? css`
          > .ListItem:not(:last-child):has(*) {
            border-bottom: 1px solid ${props => props.theme.property('palette.divider')};
          }
        ` : null}
      }
    }
    &-horizontal {
      height: 100%;
      
      &.List {
        > .ListItem {
          width: unset;
        }
        
        ${props => utils.isDefined(props.$gap) ? css`
          ${(Boolean(props.$divider) || (Boolean(props.$virtualize) && !Boolean(props.$sortable))) ? css`
            > .ListItem:not(:last-child) {
              padding-right: ${props => props.$css.$var('--list-gap-half', false)};
            }
        
            > .ListItem:not(:first-child) {
              padding-left: ${props => props.$css.$var('--list-gap-half', false)};
            }
          `: (Boolean(props.$virtualize) && Boolean(props.$sortable)) ? css`
              > .ListItem {
                padding-right: ${props => props.$css.$var('--list-gap', false)};
              }
          ` : css`
            display: flex;
            flex-direction: row;
            column-gap: ${props => props.$css.$var('--list-gap', false)};
          `}
        ` : null}
        
        ${props => Boolean(props.$divider) ? css`
          > .ListItem:not(:last-child):has(*) {
            border-right: 1px solid ${props => props.theme.property('palette.divider')};
          }
        ` : null}
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledList.propTypes = {
  theme: PropTypes.object
};

export default StyledList;
